<template>
  <div class="workflow-status-color-picker">
    <div
      v-for="curColor in ColorAssistant.StatusColorOptions"
      :key="curColor"
      :style="[{ width: colorSizeInPixels + 'px !important' }, { height: colorSizeInPixels + 'px !important' }]"
      :class="[ curColor, {'selected': color===curColor}]"
      @click="$emit('update:color', curColor)"
    />
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */

/* API */

export default defineComponent({
  name: 'WorkflowStatusColorPicker',

  props: {
    color: {
      type: String,
      required: true,
    },
    colorSizeInPixels: {
      type: Number,
      default: 20,
    },
  },

  emits: ['update:color'],

  data() {
    return {
      ColorAssistant,
    }
  },
})
</script>

<style lang="scss">
.workflow-status-color-picker {
  display: flex;
  overflow: hidden;
  @include flex-row-horizontal-spacing(2px);

  > div {
    cursor: pointer;
    opacity: 0.7;
    border-radius: 4px;

    &:hover {
      opacity: 1;
    }

    &.selected {
      opacity: 1;
      border: solid 2px var(--color-text-secondary);
    }
  }

  .dodger-blue {
    border-color: $dodger-blue;
    background-color: $dodger-blue;
  }
  .viridian {
    border-color: $viridian;
    background-color: $viridian;
  }
  .algae-green {
    border-color: $algae-green;
    background-color: $algae-green;
  }
  .bluish-grey {
    border-color: $bluish-grey;
    background-color: $bluish-grey;
  }
  .bluey-purple {
    border-color: $bluey-purple;
    background-color: $bluey-purple;
  }
  .strawberry {
    border-color: $strawberry;
    background-color: $strawberry;
  }
  .darkish-pink {
    border-color: $darkish-pink;
    background-color: $darkish-pink;
  }
  .reddish-orange {
    border-color: $reddish-orange;
    background-color: $reddish-orange;
  }
  .light-orange {
    border-color: $light-orange;
    background-color: $light-orange;
  }
}
</style>
